import { render } from "./AboutPthMitrovice.vue?vue&type=template&id=7432d254&scoped=true"
import script from "./AboutPthMitrovice.vue?vue&type=script&lang=js"
export * from "./AboutPthMitrovice.vue?vue&type=script&lang=js"

import "./AboutPthMitrovice.vue?vue&type=style&index=0&id=7432d254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7432d254"]])

export default __exports__